export const BOTTOM = "buttonBar--bottom";
export const COLUMN = "buttonBar--column";
export const TOP = "buttonBar--top";
export const FIXED = "buttonBar--fixed";
export const STICKY = "buttonBar--sticky";
export const STICKY_BOTTOM = "buttonBar--stickyBottom";
export const TABLE = "buttonBar--table";
export const MODULE = "buttonBar--module";

export const LIST = [BOTTOM, COLUMN, TOP, FIXED, STICKY, STICKY_BOTTOM, TABLE, MODULE];